import { Action, createReducer, on } from '@ngrx/store';
import { fetchSubscribersList, fetchSubscribersListSuccess, fetchSubscribersListFailure } from './subscribers.action';


export interface SubscribersState {
  list: any[];
  detail:any;
  loading: boolean;
  error: any;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

export const initialState: SubscribersState = {
  list: [],
  detail: null,
  loading: false,
  error: null,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 100,
  totalRecords: 100,
};

export const SubscribersReducer = createReducer(
  initialState,
  on(fetchSubscribersList, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchSubscribersListSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      list: response.result,
      pageNumber: response.pageNumber,
      pageSize: response.pageSize,
      totalPages: response.totalPages,
      totalRecords: response.totalRecords,
    };
  }),
  on(fetchSubscribersListFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  })
);

// Selector
export function reducer(state: SubscribersState | undefined, action: Action) {
  return SubscribersReducer(state, action);
}
